import DOMPurify from "dompurify";

import { convertSpanStyleToClasses } from "./html-transport";

function sanitizeTextFormattingStyles(root: DocumentFragment) {
  root.querySelectorAll<HTMLElement>("[style]").forEach((element) => {
    if (element.tagName !== "SPAN") {
      element.removeAttribute("style");

      return;
    }

    convertSpanStyleToClasses(element);
  });
}

function openSanitizedLinksInNewTab(root: DocumentFragment) {
  root.querySelectorAll("a").forEach((link) => {
    if (!link.getAttribute("href")) {
      link.removeAttribute("target");
      link.removeAttribute("rel");

      return;
    }

    link.setAttribute("target", "_blank");
    const relValues = new Set((link.getAttribute("rel") ?? "").split(/\s+/).filter(Boolean));

    relValues.add("noopener");
    relValues.add("noreferrer");

    link.setAttribute("rel", Array.from(relValues).join(" "));
  });
}

export function sanitizeHtml(
  htmlString: string,
  openLinksInNewTab?: boolean,
  allowTextFormattingStyles?: boolean
) {
  const sanitized = DOMPurify.sanitize(
    htmlString,
    allowTextFormattingStyles ? { ADD_ATTR: ["style"] } : undefined
  );

  if ((!openLinksInNewTab && !allowTextFormattingStyles) || typeof document === "undefined") {
    return sanitized;
  }

  const template = document.createElement("template");

  template.innerHTML = sanitized;

  if (allowTextFormattingStyles) sanitizeTextFormattingStyles(template.content);

  if (openLinksInNewTab) openSanitizedLinksInNewTab(template.content);

  return template.innerHTML;
}
